<template lang="pug">
  #app
    component(v-bind:is="layout")
      transition(name="slide-fade")
        router-view
  </div>
</template>

<script>
import { RootMapper } from '@/store';
import EventBus from '@/event-bus';
import error from '@/layouts/error.vue';

export default {
  computed: RootMapper.mapGetters(['layout']),
  components: {
    default: () => import(/* webpackChunkName: "defaultLayout" */ '@/layouts/default'),
    error,
  },
  async created() {
    window.addEventListener('resize', () => {
      EventBus.$emit('resize');
    });
  },
};
</script>

<style lang="scss">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #lhnHocButton {
    display: none!important;
  }
  .lhnChatActionsMenu { display: none !important; }
</style>
